
import dayjs from "dayjs";
import "dayjs/locale/fr";
var relativeTime = require("dayjs/plugin/relativeTime");
export function fromNow(ev) {
	dayjs.extend(relativeTime);
	dayjs.locale("fr");

	return dayjs(ev).fromNow();
}

export function toNow(ev) {
	dayjs.extend(relativeTime);
	dayjs.locale("fr");

	return dayjs(ev).toNow(true);
}

export function d_plus_1d(mode) {
	Date.prototype.addDays = function (days) {
		let date = new Date(this.valueOf());
		date.setDate(date.getDate() + days);

		return date;
	};
	let date = new Date();
	var tgdd = 1;
	if (mode === "V") {
		tgdd = 1;
	}
	if (mode === "P") {
		tgdd = 2;
	}
	const d_plus_1d = date.addDays(dt);
	const options = {
		weekday: "long",
		year: "numeric",
		month: "long",
		day: "numeric",
	};

	return d_plus_1d.toLocaleTimeString("fr-fr", options);
}

export function ValidateEmail(email) {

	if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/.test(email)) {
		return true;
	}

	return false;
}

export function ValidateCode(code) {
	if (/^[a-zA-Z0-9]{2}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}$/.test(code)) {
		return true;
	}

	return false;
}
export function ValidateNumeric(code) {

	if (/^[0-9]+$/.test(code)) {
		return true;
	}

	return false;
}
export function ValidatePhoneVerificationCode(code) {
	if (/^[0-9]{6}$/.test(code)) {
		return true;
	}

	return false;
}
export function CheckTexVal(val) {
	if (typeof (val) !== "string") return false;

	let trim_val = val.trim();
	//console.log(val, trim_val, trim_val.length);
	if (trim_val === "") return false;

	return true;
}
export function ValidatePhone(num) {
	if (num === undefined) return false;

	return /^0[6-7][0-9]{8}$/.test(num) || /^\+33[6-7][0-9]{8}$/.test(num);
}
export function ValidatePwd(pwd) {

	if (pwd === null || pwd === undefined || pwd === "") {
		return { res: false, hints: ["le mot de passe est vide"] };
	}

	if (
		/^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[!"#\$%&'\(\)\*\+,-\.\/:;<=>\?@[\]\^_`\{\|}~])[a-zA-Z0-9!"#\$%&'\(\)\*\+,-\.\/:;<=>\?@[\]\^_`\{\|}~]{6,}$/g.test(
			pwd
		)
	) {
		return { res: true };
	}
	var hints = [];
	if (!/[a-z]+/.test(pwd)) {
		hints = hints.concat(["Il manque une minuscule"]);
	}
	if (!/[A-Z]+/.test(pwd)) {
		hints = hints.concat(["Il manque une majuscule"]);
	}
	if (!/[0-9]+/.test(pwd)) {
		hints = hints.concat(["Il manque un chiffre"]);
	}
	if (!/^(?=.*?[!"#\$%&'\(\)\*\+,-\.\/:;<=>\?@[\]\^_`\{\|}~])[!"#\$%&'\(\)\*\+,-\.\/:;<=>\?@[\]\^_`\{\|}~]+$/g.test(
		pwd
	)
	) {
		hints = hints.concat(["Il manque un caractère spécial (" + pwd + ")"])
	}
	if (pwd.length < 6) {
		hints = hints.concat(["La longueur minimale est de 6 caractères"])
	}
	// if (/[.!#$%&'*+/=?^_`{|}~-)]+/.test(email)) {
	// 	hints = hints.concat(["Il manque un caractère spspécial parmi .!#$%&'*+/=?^_`{|}~-"])
	// }
	return { res: false, hints: hints };
}


